import { render, staticRenderFns } from "./ZnCommunicate.vue?vue&type=template&id=54f7bb51"
import script from "./ZnCommunicate.vue?vue&type=script&lang=js"
export * from "./ZnCommunicate.vue?vue&type=script&lang=js"
import style0 from "./ZnCommunicate.vue?vue&type=style&index=0&id=54f7bb51&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports